module.exports = __webpack_public_path__ + "static/media/IMG_20190712_151343.d9ffcc7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/IMG_20190712_151343.jpg
// module id = 115
// module chunks = 0